/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    id: -1,
    user: "",
    count: 0,
    isAdmin: ""
  },
  getters: {
    id: state => state.id,
    user: state => state.user,
    count: state => state.count,
    isAdmin: state => state.isAdmin
  },
  mutations: {
    increment() {
      this.state.count++;
    },
    selectUser(state, user) {
      state.user = user;
      //console.log("test");
      state.isAdmin = state.user.isAdmin;
    }
  }
});
